import getHelper from '../../../services/getHelper';
import type { Company } from '../../../../../index';

export default getHelper<Company>('/companies/:id', {});
